/*
 * @Author: shannyHuang
 * @Date: 2022-08-15 00:17:59
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2023-02-28 20:38:33
 * @FilePath: /wemeet-web-activity/src/hooks/useViewPoint.ts
 */
import React from 'react';

const useViewport = (size = 1024) => {
  const [width, setWidth] = React.useState(768);

  React.useEffect(() => {
    setWidth(window.innerWidth);
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  return { width, isMobileUi: width < size };
};

export default useViewport;
